var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import styled from 'styled-components';
export var StyledInputText = styled.input(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-self: stretch;\n  background: ", " no-repeat;\n  background-position: 15% 100%;\n  background-size: 0 3px;\n  border-radius: inherit;\n  border: ", ";\n  color: ", ";\n  flex-grow: 1;\n  padding: ", " ", ";\n  transition: background-size 0.3s cubic-bezier(0.64, 0.09, 0.08, 1);\n  width: 100%;\n\n  background-image: linear-gradient(\n    to left,\n    ", ",\n    ", "\n  );\n\n  &::placeholder {\n    color: ", ";\n  }\n\n  &:focus {\n    outline: 0;\n    background-size: 100% 3px;\n  }\n"], ["\n  align-self: stretch;\n  background: ", " no-repeat;\n  background-position: 15% 100%;\n  background-size: 0 3px;\n  border-radius: inherit;\n  border: ", ";\n  color: ", ";\n  flex-grow: 1;\n  padding: ", " ", ";\n  transition: background-size 0.3s cubic-bezier(0.64, 0.09, 0.08, 1);\n  width: 100%;\n\n  background-image: linear-gradient(\n    to left,\n    ", ",\n    ", "\n  );\n\n  &::placeholder {\n    color: ", ";\n  }\n\n  &:focus {\n    outline: 0;\n    background-size: 100% 3px;\n  }\n"])), function (p) {
  return p.theme.colorLevel(p.theme.lowContrast, 0.5);
}, function (p) {
  return p.error ? '1px ' + p.theme.danger + ' solid' : 0;
}, function (p) {
  return p.theme.textPrimary;
}, function (p) {
  return p.theme.inputPaddingY;
}, function (p) {
  return p.theme.inputPaddingX;
}, function (p) {
  return p.theme.themeName === 'dark' || p.theme.themeName === 'newlight' ? p.theme.primaryA : p.theme.themeName === 'greenlight' ? p.theme.primaryA : p.theme.colorLevel(p.theme.primary, 3);
}, function (p) {
  return p.theme.themeName === 'dark' || p.theme.themeName === 'newlight' ? p.theme.primaryB : p.theme.themeName === 'greenlight' ? p.theme.primaryB : p.theme.colorLevel(p.theme.primary, -3);
}, function (p) {
  return p.theme.themeName === 'greenlight' ? p.theme.textSecondary : p.theme.textTertiary;
});

var InputText = function InputText(_a) {
  var inputRef = _a.inputRef,
      name = _a.name,
      props = __rest(_a, ["inputRef", "name"]);

  return React.createElement(StyledInputText, Object.assign({
    ref: inputRef,
    className: "input-text",
    type: "text",
    name: name
  }, props));
};

export default InputText;
var templateObject_1;